import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "cart-sum__parts" };
const _hoisted_2 = { class: "cart-parts" };
const _hoisted_3 = { class: "cart-parts__row" };
const _hoisted_4 = { class: "cart-parts__value" };
const _hoisted_5 = { class: "cart-parts__label" };
import Price from "../Price.vue";
import { isToday } from "date-fns";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderSumBNPL',
    props: {
        payments: { type: Array, required: true },
        showFractions: { type: [Boolean, String], },
    },
    setup(__props) {
        function formatDate(date) {
            if (isToday(date)) {
                return 'сегодня';
            }
            return date.toLocaleDateString(navigator.language, {
                month: 'long',
                day: 'numeric',
            }).replace(' ', ' ');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "cart-parts__title" }, "Оплата частями", -1 /* CACHED */)),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.payments, (payment, key) => {
                            return (_openBlock(), _createElementBlock("div", {
                                class: "cart-parts__col",
                                key: key
                            }, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createVNode(Price, {
                                        amount: payment.amount,
                                        "show-fractions": "auto"
                                    }, null, 8 /* PROPS */, ["amount"])
                                ]),
                                _cache[0] || (_cache[0] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_5, _toDisplayString(formatDate(payment.date)), 1 /* TEXT */)
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ])
            ]));
        };
    }
});
